import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { EModuleIDs } from 'app/consts/enums';
import { SharedService } from 'app/services/shared.service';

@Injectable({ providedIn: 'root' })
export class DefaultRouteGuard implements CanActivate {
  constructor(
    private sharedService: SharedService,
    private router: Router,
  ) { }

  canActivate(): UrlTree {
    const target = this.sharedService.isIntellifleet ? EModuleIDs.SafetyReport : EModuleIDs.Manifests;
    // Build the URL via linkToPage (the same helper the rest of the app navigates with)
    // and parseUrl, rather than createUrlTree([MAIN_ROUTE, ROUTES[target]]). Multi-segment
    // module URLs like SafetyReport ('safety_management/report') contain a slash; passed as a
    // single createUrlTree command segment the slash is not treated as a separator, producing a
    // URL that matches no route (NG04002). This only affected Intellifleet, whose landing module
    // is a multi-segment route; Manifests ('manifests') has no slash so normal users were fine.
    return this.router.parseUrl(this.sharedService.linkToPage(target));
  }
}